@if (versionNumber$ | async) {
  <span class="version-number">v.{{ versionNumber$ | async }}</span>
}
